export default function (caseNumber) {
  return {
    name: "Request NOD Extension",
    pageInfo: {
      text: "Please upload a NOD extension request. Your request will be added to the case documents and directed to an analyst to review.",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "Request_Extension_Case_Number",
            widget: "text",
            label: "Case Number *",
            maxLength: 100,
            disabled: true,
            value: caseNumber || "",
          },
          {
            machine_name: "fileType",
            widget: "text",
            value: "Extension Request - 9142C NOD",
            style: {
              display: "none",
            },
          },
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "Extension Request - 9142C NOD" },
            accept_multiple: true,
            required: true,
            validate: ["required", "file_required"],
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
        ],
      },
    ],
  };
}
